import React from "react";
import { PendingButton } from "components/common";
import constructRow from "./constructRow";
import { isArray } from "lodash";

export const jsonToCsv = (data, name) => { 
  var encodedUri = "data:text/csv;charset=utf-8,%EF%BB%BF" + encodeURIComponent(data.join("\n"));
  var link = document.createElement("a");
  link.setAttribute("href", encodedUri);
  link.setAttribute("download", `${name}.csv`);
  link.click();
};

const exportCSV = (data, constructProps) => {
  let csvData = [];
  data.ReportTitles.map((x) => csvData.push([x]));
  csvData.push([]);

  data.Rows.forEach(function (i, idx) {
    let r = constructRow(i, idx, {
      ...constructProps,
      asJson: true,
    });
    if (isArray(r[0])) {
      r.map((x) => csvData.push(x));
    } else {
      csvData.push(r);
    }
  });
  jsonToCsv(csvData, data.ReportTitles[0]);
};

export default ({ data, constructProps = {} }) => (
  <PendingButton
    color="primary"
    onClick={() => exportCSV(data, constructProps)}
  >
    Export
  </PendingButton>
);
